import CircularProgress, {
  circularProgressClasses,
} from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import LoaderIco from 'src/assets/icons/loader-ico.svg';
import React from 'react';
import { useTheme } from '@mui/material/styles';

interface Props {
  color?: string;
  Icon?: any;
  size?: any;
  spinnerAlign?: any;
  styles?: any;
  spinnerStyles?: any;
}

const Loader: React.FC<Props> = ({
  color,
  styles = {},
  spinnerStyles = {},
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'fixed',
        backgroundColor: 'rgba(255,255,255,0.9)',
        zIndex: 999,
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        ...styles,
      }}
    >
      <Box position="relative" sx={{ ...spinnerStyles }}>
        <CircularProgress
          variant="determinate"
          sx={{
            color: (theme) => '#E7E6E9',
          }}
          size={114}
          thickness={3}
          value={100}
        />
        <CircularProgress
          size={114}
          thickness={3}
          variant="indeterminate"
          sx={{
            color: (theme) => color || theme.palette.primaryColor,
            animationDuration: '1500ms',
            position: 'absolute',
            left: 0,
            [`& .${circularProgressClasses.circle}`]: {
              strokeLinecap: 'round',
            },
          }}
        />

        <Box
          position="absolute"
          sx={{ top: '50%', right: '50%', transform: 'translate(50%,-50%)' }}
        >
          <LoaderIco color={color || theme.palette.primaryColor} />
          <Typography
            fontSize={14}
            position="absolute"
            sx={{
              top: 'calc(50% + 85px)',
              right: '50%',
              transform: 'translate(50%,-50%)',
            }}
          >
            Loading
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default Loader;
